var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M7,14.7a1.6,1.6,0,0,1-.762-.19L6,14.384A11.241,11.241,0,0,1,0,4.537V4.429a1.488,1.488,0,0,1,.792-1.3L6.238.191a1.62,1.62,0,0,1,1.524,0l5.445,2.938A1.489,1.489,0,0,1,14,4.429v.108a11.241,11.241,0,0,1-6,9.847l-.234.127A1.609,1.609,0,0,1,7,14.7ZM7,1.49,1.555,4.429v.108a9.761,9.761,0,0,0,5.209,8.547L7,13.212l.235-.127a9.761,9.761,0,0,0,5.209-8.547V4.429L7,1.49Z",
    transform: "translate(0 0)",
    fill: "#5ad2e2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Badge_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badge_1",
    "data-name": "Badge 1",
    clipPath: "url(#clip-Badge_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(5 4.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Icon_\\u0421olor-2",
    "data-name": "\\uD83C\\uDFA8 Icon \\u0421olor",
    d: "M7,14.7a1.6,1.6,0,0,1-.762-.19L6,14.384A11.241,11.241,0,0,1,0,4.537V4.429a1.488,1.488,0,0,1,.792-1.3L6.238.191a1.62,1.62,0,0,1,1.524,0l5.445,2.938A1.489,1.489,0,0,1,14,4.429v.108a11.241,11.241,0,0,1-6,9.847l-.234.127A1.609,1.609,0,0,1,7,14.7ZM7,1.49,1.555,4.429v.108a9.761,9.761,0,0,0,5.209,8.547L7,13.212l.235-.127a9.761,9.761,0,0,0,5.209-8.547V4.429L7,1.49Z",
    transform: "translate(0 0)",
    fill: "#5ad2e2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/Badge.3ff41325fd316c4fe5a8a0dd1dcf60ac.svg";
export { ForwardRef as ReactComponent };